// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"58b680e2","172":"df90c020","213":"ccb6b100","312":"4b90d08a"}[chunkId] + ".css";
};